// extracted by mini-css-extract-plugin
export var content = "_dw-3";
export var list = "_dw-4";
export var settingsContent = "_dw-7";
export var settingsPanel = "_dw-8";
export var state = "_dw-6";
export var triggerBadge = "_dw-2";
export var triggerButton = "_dw-1";
export var triggerShell = "_dw-0";
export var unreadDot = "_dw-5";